/** Etiquetas de medios de pago para tickets y reportes. */
export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  cash: "Efectivo",
  card_credit: "Tarjeta de crédito",
  card_debit: "Tarjeta de débito",
  yape: "Yape",
  plin: "Plin",
  transfer: "Transferencia",
  other: "Otro",
};
